export default __webpack_public_path__ + "static/media/fish_oil9.cb88e69d.png";